import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: -12,
        padding: `0 0 ${theme.spacing(2)} 0`,
    },
    typography: {
        color: theme.colors.gray[800],
    },
}));
//# sourceMappingURL=DialogDescription.styles.js.map